
(function ($) {
    $.fn.drawer = function(options) {
        var defaults = {
        };

        options = $.extend(defaults, options);

        return this.each(function() {

            var $this = $(this);
            var $drawer = $($this.data("drawer"));
            var bStartOpen = $drawer.is(".is-open");
            var drawerTrigger = $drawer.find('.drawer-trigger');
            drawerTrigger.attr('aria-expanded', bStartOpen);

            // Add click handler
            $this.on('click', function(e) {
                $drawer.toggleClass("is-open");
                drawerTrigger.attr('aria-expanded', $drawer.is('.is-open'));
            });
});
};

$(document).ready(function(){
    $(".drawer-trigger").drawer();
});
}( jQuery ));
